import { render, staticRenderFns } from "./albums.vue?vue&type=template&id=066368d7&scoped=true&"
import script from "./albums.vue?vue&type=script&lang=ts&"
export * from "./albums.vue?vue&type=script&lang=ts&"
import style0 from "./albums.vue?vue&type=style&index=0&id=066368d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066368d7",
  null
  
)

export default component.exports